import ky from "ky";

export const handleClose = () => {
  window.location.href = "/";
};

export const postTransaction = async (
  url: string,
  token: string,
  json: Record<string, string>
) => {
  try {
    await ky.post(url, {
      headers: { Authorization: `Bearer ${token}` },
      json,
    });
  } catch (error) {
    console.error("Transaction error:", error);
  }
};
